export default __webpack_public_path__ + "static/fa-regular-400-b6621322a518078618da201b913ae7cd.svg";